/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../../api.js";
import util from "../../util/util.js";

import "./shared-sites/manage-shared-sites-home.js";
import "./shared-sites/manage-shared-sites-edit.js";

function ManageSharedSitesViewModel(params) {
	var self = this;

	self.currentComponent = ko.observable();

	self.editLayer = function(id) {
		show('manage-shared-sites-edit', { id: id });
	}

	self.listLayers = function() {
		show('manage-shared-sites-home');
	}

	function show(name, params, dontUpdateHash) {
		params = params || {};

		var componentParams = Object.assign({ parent: self }, params);
		self.currentComponent({ name: name, params: componentParams });

		if(!dontUpdateHash) {
			var p = util.hashParams();
			p.sub = name;
			p.sp = JSON.stringify(params);
			util.updateHashParams(p);
		}
	}

	function setupHistory() {
		window.addEventListener('hashchange', handleHashChange);
		handleHashChange();
		if(!self.currentComponent()) {
			self.listLayers(); // Default page
		}
	}

	function handleHashChange() {
		var hp = util.hashParams();
		var name = hp.sub;
		var params = {};
		try {
			params = JSON.parse(hp.sp);
		} catch(e) {}

		if(name) {
			var cur = self.currentComponent();
			if(!cur || cur.name != name) {
				show(name, params);
			}
		} else {
			show("manage-shared-sites-home", undefined, true);
		}
	}

	self.dispose = function() {
		window.removeEventListener('hashchange', handleHashChange);
	}

	setupHistory();
}


ko.components.register('manage-shared-sites', {
	viewModel: function(params) {
		return new ManageSharedSitesViewModel(params);
	},
	template: require('../../../templates/admin/manage-shared-sites.html')
});


